import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';
import { TEXT_FIELD_IS_REQUIRED } from '../../../utils/messages';
import './CustomMultySelectSex.scss';

export default class CustomMultiSelectSex extends React.Component {
  constructor(props) {
    super(props);
    this.pullgenders = Object.keys(props.pullgenders);

    this.state = {
      open: false,
      focused: 0,
      filter: '',
      value: this.getTimezone(props.defaultValue || props.value),
    };
  }
  componentDidMount() {
    const { name, registerField } = this.props;
    registerField({ name, validator: this.standardValidator });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const newValue = this.getTimezone(this.props.value);
      this.field.value = newValue || '';
      this.setState({ value: newValue });
    }
  }
  getTimezone(query) {
    if (!query) { return null; }
    return this
      .pullgenders
      .find(zone => query === this.props.pullgenders[zone] || query === zone);
  }

  filteredTimezones() {
    return this
      .pullgenders
      .filter(this.filterItems(this.state.filter));
  }

  filterItems = (filter) => {
    if (!filter.trim() === '') { return () => true; }
    return zone => zone
      .toLowerCase()
      .includes(filter.toLowerCase().replace(/\s/g, ''));
  }

  handleFocus(e) {
    this.field.value = '';
    this.setState({ open: true });

    if (typeof this.props.inputProps.onFocus === 'function') {
      this
        .props
        .inputProps
        .onFocus(e);
    }
  }

  handleBlur(e) {
    this.field.value = this.state.value || '';
    if (!this.field.value) {
      this
        .props
        .onChange({ name: this.props.name, value: '' });
    }

    this.setState({ open: false });

    if (typeof this.props.inputProps.onBlur === 'function') {
      this
        .props
        .inputProps
        .onBlur(e);
    }
  }

  handleFilterChange(e) {
    const filter = this
      .field
      .value
      .trim();
    this.setState({ filter, focused: 0 });

    if (typeof this.props.inputProps.onChange === 'function') {
      this
        .props
        .inputProps
        .onChange(e);
    }
  }

  handleKeyPress(e) {
    const filteredTimezones = this.filteredTimezones();
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();

      let { focused } = this.state;
      if (e.key === 'ArrowUp') {
        focused -= 1;
        if (focused < 1) { focused = filteredTimezones.length; }
      } else {
        focused += 1;
        if (focused > filteredTimezones.length) { focused = 1; }
      }
      this.setState({ focused });
      this
        .options
        .children[focused % this.options.children.length]
        .scrollIntoView();
    } else if (e.key === 'Enter') {
      const zone = filteredTimezones[this.state.focused % filteredTimezones.length];
      if (zone) {
        this.handleSelect(zone);
        e
          .target
          .blur();
      } else {
        this.setState({ focused: 0 });
      }
    }
  }
  standardValidator = (value) => {
    const { isRequired } = this.props;
    let valid = true;
    let errorText = '';

    if (isRequired && !value.length) {
      valid = false;
      errorText = TEXT_FIELD_IS_REQUIRED;
    }
    const status = valid
      ? TEXT_FIELD_STATUS.VALID
      : TEXT_FIELD_STATUS.INVALID;

    return { status, errorText };
  };
  handleSelect(zone) {
    this.setState({ filter: '', focused: 0, open: false });
    if (this.props.onChange) {
      this
        .props
        .onChange({ name: this.props.name, value: this.props.pullgenders[zone] });
    } else {
      this.field.value = zone;
      this.setState({ value: zone });
    }
  }

  handleItemFocus(index) {
    this.setState({ focused: index });
  }

  value() {
    const currentValue = this.state.value;
    if (!currentValue) { return null; }

    return this.props.pullgenders[currentValue];
  }

  render() {
    const {
      inputProps, errorText, status, disabled,
    } = this.props;
    const { value } = this.state;
    const showError = status === TEXT_FIELD_STATUS.INVALID;
    const isSelected = !this.state.open && value;
    const isOpen = this.state.open;
    const showPlaceholder = !(isOpen || isSelected);
    const { placeholder } = inputProps;
    return (
      <div
        className={classNames('timezone-picker-sex', {
          'timezone-picker-open': isOpen,
          'timezone-picker-selected': isSelected,
          'show-float-label': isOpen || isSelected,
          'text-field-failed': showError,
          disabled,
        }, this.props.className)}
        style={this.props.style}
      >
        <div className="text-field-float-label">
          <span>{placeholder}</span>
        </div>
        <div className="timezone-picker-textfield">

          <div className="arrow-down" />
          <input
            disabled={disabled}
            type="text"
            onFocus={e => this.handleFocus(e)}
            onBlur={e => this.handleBlur(e)}
            onChange={e => this.handleFilterChange(e)}
            onKeyDown={e => this.handleKeyPress(e)}
            defaultValue={value}
            ref={(field) => {
              this.field = field;
            }}
            autoComplete="off"
            {...inputProps}
            placeholder={showPlaceholder
              ? placeholder
              : ''}
          />
        </div>

        <div className="text-field-error-text">
          <span>{errorText}</span>
        </div>
        <ul
          className="timezone-picker-list"
          ref={(options) => {
            this.options = options;
          }}
        >
          {this
            .filteredTimezones()
            .map((zone, index, arr) => {
              const focused = this.state.focused % arr.length === index;
              return (
                <button
                  key={zone}
                  title={zone}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  onMouseDown={() => this.handleSelect(zone)}
                  onMouseOver={() => this.handleItemFocus(index)}
                  onFocus={() => this.handleItemFocus(index)}
                  className={classNames('timezone-picker-list-item', { 'timezone-picker-list-item-active': focused })}
                >
                  {zone}
                </button>
              );
            })}
        </ul>
      </div>
    );
  }
}

CustomMultiSelectSex.propTypes = {
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  isRequired: PropTypes.bool,
  inputProps:
    PropTypes.shape({ onBlur: PropTypes.func, onFocus: PropTypes.func, onChange: PropTypes.func }),
  registerField: PropTypes.func,
  name: PropTypes.string.isRequired,
  pullgenders: PropTypes.shape({}),
  errorText: PropTypes.string,
  status: PropTypes.string.isRequired,
};

CustomMultiSelectSex.defaultProps = {
  defaultValue: '',
  value: '',
  onChange: () => {},
  registerField: () => {},
  className: '',
  style: {},
  disabled: false,
  errorText: '',
  inputProps: {},
  isRequired: false,
  pullgenders: require('./genders.json'), // eslint-disable-line global-require
};



// WEBPACK FOOTER //
// ./src/components/_molecules/CustomMultySelectSex/CustomMultySelectSex.js